import { IRepository } from '../../infrastructure/repository.interface';
import { Injectable } from '@angular/core';
import { ReferenceTableModel } from '@shared';
import { WorkspaceDatabaseProvider } from '../workspace-database.provider';
import { from, Observable } from 'rxjs';
import { RefTablesStorageService } from '../services/ref-tables-storage.service';
import { QueryParamsProvider } from '@domain/routing';

@Injectable()
export class ReferenceTableRepository implements IRepository<ReferenceTableModel> {
	public constructor(
		private dbProvider: WorkspaceDatabaseProvider,
		private refTablesStorageService: RefTablesStorageService,
		private queryParamsProvider: QueryParamsProvider
	) {}

	public async insert(entity: ReferenceTableModel): Promise<void> {
		const database = this.dbProvider.getCurrentDatabaseInstance();

		await database.referencetables.insert(entity);
	}

	public getAll(reftableName: string): Observable<ReferenceTableModel[]> {
		return from(
			this.refTablesStorageService
				.get<ReferenceTableModel[]>(this.queryParamsProvider.workfileId, reftableName)
				.then((refTables: any) => {
					if (!refTables) {
						return [];
					}

					return refTables;
				})
		);
	}
}
